import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../panels/BasePanelPage";
import {Messages} from "../../../../Messages";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {MerchantButton} from "../../../../common/MerchantButton";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {PanelToast} from "../../../PanelToast";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";


@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardSubscribeChangeSuccessPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.subscribeChangeSuccess,
        }
    }

    render() {
        return [
            <MessageElement message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())}/>,
            <MerchantButton label={Messages.ok} className={this.styleSheet.button}
                            onClick={() => {
                                Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
                                PanelToast.showSuccess(Messages.changesSaved);
                            }}/>,
        ];
    }
}
